export default __webpack_public_path__ + "static/media/PPF.43f858b2.webp";